/** @format */

import { createRouter, createWebHistory } from "vue-router";
import Home from "../views/Home.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/size",
    name: "Sizes",
    component: () => import("../views/Sizes.vue"),
  },
  {
    path: "/commitment",
    name: "Commitment",
    component: () => import("../views/Commitment.vue"),
  },
  {
    path: "/details",
    name: "Details",
    component: () => import("../views/Details.vue"),
  },
  {
    path: "/offers",
    name: "Offers",
    component: () => import("../views/Offers.vue"),
  },
  {
    path: "/new/",
    name: "New",
    component: () => import("../views/New.vue"),
  },
  {
    path: "/newmobile/",
    name: "NewMobile",
    component: () => import("../views/NewMobile.vue"),
  },
  {
    path: "/quote/:id",
    name: "Quote",
    component: () => import("../views/Quote.vue"),
  },
];

const router = createRouter({
  mode: "history",
  history: createWebHistory("/gamma"),
  routes,
});

router.beforeEach((to, from, next) => {
  const currentPath = window.location.pathname;
  // Remove the base URL from route paths
  const fromPath = currentPath.replace("/gamma", "");
  const isReloading = fromPath === to.path;
  console.log(isReloading);
  console.log(fromPath);
  console.log(to.path);
  if (!isReloading) {
    fetch("https://www.googletagmanager.com/gtm.js?id=GTM-5VNPS9JR")
      .then((response) => response.text())
      .then((scriptText) => {})
      .catch((error) => {
        console.error("Error loading script:", error);
      });
    next();
  } else if (to.path == "/" || fromPath.includes("/quote/")) {
    next();
  } else {
    next("/");
  }
  // next();
  // Google Tag Manager script
});
//GAMMA/ history: createWebHistory('/gamma'),
//REGULAR: history: createWebHistory(process.env.BASE_URL),

/*
GAMMA:
  {
    path: '/size/',
    name: 'Sizes',
    component: () => import('../views/Sizes.vue')
  },

REGULAR:
  {
    path: '/size/:g_size?/:g_rounded?/:g_offer?/:g_list?',
    name: 'Sizes',
    component: () => import('../views/Sizes.vue')
  },

*/

export default router;
